var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCongratulations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 273.8 154.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #dee4ff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke: #dfe5ff;\n      }\n\n      .cls-3, .cls-5 {\n        stroke: #da1c4e;\n      }\n\n      .cls-4 {\n        stroke: #2866ad;\n      }\n\n      .cls-5 {\n        stroke-width: .75px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Congratulations_v2_2",
    "data-name": "Congratulations v2_2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.17,
    y1: 13.63,
    x2: 0.75,
    y2: 13.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.83,7.06v-.02c0-3.47,2.82-6.29,6.29-6.29s6.29,2.82,6.29,6.29c0,3.47-2.82,6.29-6.29,6.29l-24.27.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 222.83,
    y1: 37.72,
    x2: 211.84,
    y2: 37.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.05,18.96c-1.05-4.14-4.8-7.21-9.26-7.21-2.93,0-5.56,1.32-7.32,3.4-1.41,1.67-2.25,3.82-2.25,6.17,0,.2.02.4.03.6-.95-.39-1.99-.6-3.08-.6-4.53,0-8.2,3.67-8.2,8.2,0,4.53,3.67,8.2,8.2,8.2h-19.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "138.65 4.5 142.57 5.07 139.73 7.83 140.4 11.74 136.9 9.89 133.4 11.74 134.07 7.83 131.23 5.07 135.15 4.5 136.9 .95 138.65 4.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "37.93 65.61 39.44 61.95 41.43 65.38 45.37 65.68 42.73 68.63 43.65 72.48 40.03 70.87 36.66 72.94 37.07 69 34.06 66.43 37.93 65.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m58.57,71.81c-3.04-1.13-6.32-1.87-9.75-1.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m79.38,87.08s-6.44-8.11-16.2-13.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.56,80.92c-2.73-1.87-6.08-3.56-9.65-3.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 136.9,
    y1: 29.7,
    x2: 136.9,
    y2: 62.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 136.9,
    y1: 16.15,
    x2: 136.9,
    y2: 23.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "237.8 94.53 236.95 90.67 234.4 93.69 230.46 93.3 232.54 96.66 230.95 100.29 234.8 99.34 237.75 101.98 238.04 98.03 241.46 96.03 237.8 94.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m216.39,96.99c3.19-.57,6.55-.73,9.95-.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m193.2,108.36s7.77-6.85,18.28-10.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m200.38,109.31s1.61-1.33,4.13-2.81"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "157.11 95.68 154.37 87.79 157.06 84.28 159.78 92.2 157.11 95.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "150.94 103.72 148.2 95.83 150.89 92.32 153.61 100.24 150.94 103.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "144.77 111.76 142.03 103.87 144.73 100.36 147.44 108.27 144.77 111.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "150.82 92.41 152.08 95.77 157.16 95.61 155.91 92.24 150.82 92.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "144.62 100.49 145.88 103.85 150.96 103.69 149.72 100.32 144.62 100.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "137.69 109.26 140.65 112.18 144.76 111.77 143.52 108.4 137.69 109.26"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "133.57 83.8 138.84 89.06 139.63 85.23 134.37 79.93 133.57 83.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "137.01 97.91 131.75 92.65 132.54 88.78 137.8 94.08 137.01 97.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "135.18 106.76 129.92 101.5 130.72 97.63 135.97 102.93 135.18 106.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "132.52 88.89 134.84 91.09 138.85 88.99 136.54 86.77 132.52 88.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "130.69 97.78 133 99.99 137.02 97.89 134.7 95.66 130.69 97.78"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "163.34 113.6 168.6 118.87 172.47 118.08 167.17 112.82 163.34 113.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "154.49 115.43 159.75 120.7 163.62 119.9 158.32 114.64 154.49 115.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "145.64 117.25 150.9 122.52 154.77 121.72 149.47 116.46 145.64 117.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "163.51 119.92 161.31 117.6 163.41 113.59 165.63 115.9 163.51 119.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "154.62 121.75 152.41 119.44 154.52 115.42 156.74 117.73 154.62 121.75"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "129.84 101.4 150.88 122.48 116.88 135.18 129.84 101.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "136.71 108.28 143.08 125.39 150.88 122.48 136.71 108.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "136.09 128 127.98 106.26 123.81 117.13 128.99 130.65 136.09 128"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "119.77 127.64 121.94 133.29 116.88 135.18 119.77 127.64"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "119.3 78.57 121.27 78.71 119.96 80.19 120.44 82.11 118.63 81.32 116.95 82.37 117.14 80.4 115.62 79.13 117.55 78.7 118.29 76.86 119.3 78.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.68,
    y1: 96.9,
    x2: 41.5,
    y2: 96.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m7.01,90.64c0,1.74,1.41,3.16,3.16,3.16.84,0,1.6-.33,2.17-.86.61-.58.99-1.39.99-2.3v-.02c0-3.47-2.82-6.29-6.29-6.29s-6.29,2.82-6.29,6.29,2.82,6.29,6.29,6.29h15.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m113.2,83.03c-5.52,4.54-9.8,10.51-12.26,17.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m98.61,113.82c0,22.07,18.02,39.96,40.25,39.96,16.9,0,31.37-10.34,37.33-25"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratulations);
export default __webpack_public_path__ + "static/media/Congratulations.5a00131169fa90433947552fa8252f8a.svg";
export { ForwardRef as ReactComponent };